import { Close } from "@mui/icons-material";
import { FormControl, FormHelperText, Grid, InputLabel, OutlinedInput, Typography } from "@mui/material";
import { isNumber } from "lodash";
import React, { FC, useId } from "react";
import { useSelector } from "react-redux";
import { AppState } from "../../../reducers";
import LocaleSelector from "../../locale/localeSelector";
import LocaleAutoTranslateSelector from "../../locale/localeAutoTranslateSelector";
import { useTranslation } from "react-i18next";

export interface TextWithTranslationLabel {
    value: any;
    label: string;
    setLanguage: ({ id, value, arrayId }: { id: number; value: string; arrayId?: number }) => void,
    multiline?: number;
    arrayId?: number;
    error?: string;
    remaining_character?: number;
    size?: 'small' | 'medium';
}

export const TextWithTranslation: FC<TextWithTranslationLabel> = ({ value, label, size, multiline, arrayId, error, remaining_character, setLanguage }) => {
    const { t } = useTranslation();
    const dom_id = useId();
    const locales = useSelector((state: AppState) => state.locale.list);
    const current_locale = useSelector((state: AppState) => state.locale.current_locale);
    const onUpdate = (id: number, value: string) => {
        if (isNumber(arrayId)) {
            setLanguage({ id, value, arrayId });
        } else {
            setLanguage({ id, value });
        }
    };
    return <Grid container spacing={size === 'small' ? 1 : 2}>
        <Grid item xs={6}>
            <LocaleSelector size={size} id={`${dom_id}-lang`} values={value} />
        </Grid>
        <Grid item xs={12}>
            {
                current_locale !== null && locales && locales.map((locale) => {
                    if (locale.id === current_locale) {
                        return (
                            <FormControl size={size} key={`${dom_id}-${locale.language_code}`} fullWidth variant={'outlined'} error={!!error}>
                                <InputLabel size={size === "medium" ? "normal" : size} htmlFor={`${dom_id}-${locale.language_code}`}>{label} ({locale.language_code})</InputLabel>
                                <OutlinedInput
                                    id={`${dom_id}-${locale.language_code}`}
                                    type={'text'}
                                    multiline={!!isNumber(multiline)}
                                    rows={isNumber(multiline) ? multiline : 1}
                                    onChange={(event) => onUpdate(locale.id, event.target.value)}
                                    label={`${label} (${locale.language_code})`}
                                    value={value[locale.id] ? value[locale.id] : ''}
                                    error={!!error}
                                    autoComplete={'off'}
                                    size={size}
                                    endAdornment={<>
                                        <Close className={'ft-user-closeIcon'} onClick={() => onUpdate(locale.id, '')} />
                                        {isNumber(remaining_character) && <Typography variant="body2" color="textSecondary" className='input-adornment-fixed'>
                                            {t('shared.remaining-character', { count: remaining_character })}
                                        </Typography>}
                                    </>
                                    }
                                />
                                <FormHelperText>{error}</FormHelperText>
                            </FormControl>
                        );
                    }
                })
            }
        </Grid>
        <Grid item xs={12}>
            <LocaleAutoTranslateSelector size={size} id={`LocaleAutoTranslate-${label}`} values={value} onTranslation={onUpdate} />
        </Grid>
    </Grid>;
};